import { ProductQuestion } from '../types';
import { questionRepository } from '../../data/questionRepository';

export const questionService = {
    async getQuestionsByProduct(productId: string, limitCount: number = 20): Promise<ProductQuestion[]> {
        return questionRepository.getAnsweredQuestionsByProduct(productId, limitCount);
    },

    async createQuestion(question: Omit<ProductQuestion, 'id' | 'createdAt' | 'updatedAt' | 'helpful' | 'notHelpful' | 'status'>): Promise<string> {
        const questionId = await questionRepository.createQuestion(question);
        await questionRepository.createQuestionNotification({
            id: questionId,
            productId: question.productId,
            shopId: question.shopId,
            partnerId: question.partnerId,
            userId: question.userId,
            userName: question.userName,
            question: question.question,
            status: 'pending',
            helpful: 0,
            notHelpful: 0,
            isVerifiedPurchase: false,
            hideFromPublic: false
        } as unknown as ProductQuestion);
        return questionId;
    },

    async answerQuestion(questionId: string, answer: string, partnerId: string): Promise<void> {
        await questionRepository.answerQuestion(questionId, answer, partnerId);
    },

    async voteQuestionHelpful(questionId: string, userId: string): Promise<boolean> {
        return questionRepository.voteHelpful(questionId, userId);
    },

    async voteQuestionNotHelpful(questionId: string, userId: string): Promise<boolean> {
        return questionRepository.voteNotHelpful(questionId, userId);
    },

    async reportQuestion(questionId: string, userId: string, reason: string): Promise<void> {
        await questionRepository.reportQuestion(questionId, userId, reason);
    },

    async getPendingQuestionsByShop(shopId: string): Promise<ProductQuestion[]> {
        return questionRepository.getPendingQuestionsByShop(shopId);
    },

    async getQuestionStats(productId: string): Promise<{ total: number; answered: number; pending: number }> {
        return questionRepository.getQuestionStats(productId);
    }
};
